import React from 'react';

import Dialog from 'material-ui/Dialog';
import { Link } from 'react-router-dom';

import './alert.css';

const NewUser = ({ closeDialog, isDialogOpen }) => (
  <Dialog
    actions={
      <div className="buttons-div">
        <Link to="/profile">
          <button type="button" className="alert-button" onClick={closeDialog}>
            OK
          </button>
        </Link>
      </div>
    }
    open={isDialogOpen}
    paperProps={{ style: { borderRadius: '4px' } }}>
    <p style={{ textAlign: 'center' }}>
      You've successfully submitted your application! Our team will be in contact with you within 3-5 business days.
    </p>
  </Dialog>
);

export default NewUser;



// WEBPACK FOOTER //
// ./src/components/Alert/NewUser.js